'use strict';

angular
  .module('ClinicApp')
  .directive('appNotification', (NotificationService) => ({
    restrict: 'E',
    templateUrl: '/views/directives/app-notification.html',
    scope: {
      notification: '=',
      clinicId: '=',
    },
    link: ($scope) => {
      $scope.title = $scope.notification.title;
      $scope.icon = $scope.notification.icon;
      $scope.body = $scope.notification.body;

      $scope.timestamp = $scope.notification.data?.timestamp || null;

      const link = $scope.notification.data?.link || null;
      $scope.clickable = Boolean(link);

      $scope.clearNotification = (event) => {
        event.stopPropagation();
        NotificationService.clearNotification($scope.notification.id);
      };

      $scope.onNotificationClick = (event) => {
        event.stopPropagation();

        if (!link) {
          return;
        }

        NotificationService.trackNotificationClicked(
          $scope.notification,
          $scope.clinicId,
        );
        NotificationService.clearNotification($scope.notification.id);
        window.location.href = link;
      };

      NotificationService.trackNotificationShown(
        $scope.notification,
        $scope.clinicId,
      );
    },
  }));
